/**
 * Legal / disclosure link targets (bug preservoir-client#155).
 *
 * The policies moved from PDFs in the dev blob container to Termly and the marketing
 * site's Disclosures page — these constants are the single source of truth for those
 * destinations. They are environment-invariant by design (no env switching): Termly and
 * preservoir.co.uk are the same targets in every environment.
 *
 * "Contact us" deliberately remains the public-docs PDF for now.
 */

/** Marketing-site Disclosures page (replaces Best-Execution-Policy + Important-Investment-Notes PDFs). */
export const DISCLOSURES_URL = 'https://preservoir.co.uk/disclosures';

/** Buy-flow "risk of investing" anchor on the Disclosures page. */
export const DISCLOSURES_RISKS_URL = `${DISCLOSURES_URL}#risks`;

/** Buy-flow "costs and charges" anchor on the Disclosures page. */
export const DISCLOSURES_COSTS_AND_CHARGES_URL = `${DISCLOSURES_URL}#costs-and-charges`;

/** Termly-hosted Privacy policy. */
export const PRIVACY_POLICY_URL =
  'https://app.termly.io/policy-viewer/policy.html?policyUUID=64ace475-d9a1-4169-a04e-b252114e8626';

/** Termly-hosted Terms & Conditions (replaces the Terms-of-Use PDF). */
export const TERMS_AND_CONDITIONS_URL =
  'https://app.termly.io/policy-viewer/policy.html?policyUUID=280a775b-ded8-45e0-a0fc-4dba569da660';

/** Termly-hosted Cookie Policy. */
export const COOKIE_POLICY_URL =
  'https://app.termly.io/policy-viewer/policy.html?policyUUID=28118619-a1a2-4554-a04a-d4ce066cf412';

/** Contact-us PDF — explicitly unchanged ("remains as is"). */
export const CONTACT_US_URL =
  'https://preservoirblobdev.blob.core.windows.net/public-docs/Contact-Us.pdf';
